"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemHolder = exports.DetailsRoot = exports.DetailsContainer = exports.Counter = exports.CloseButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const DetailsRoot = exports.DetailsRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  justifyItems: 'center',
  alignItems: 'end',
  justifyContent: 'center',
  alignContent: 'end',
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: theme.zIndex.modal,
  [theme.breakpoints.up('lg')]: {
    justifyItems: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center'
  }
}));
const DetailsContainer = exports.DetailsContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  position: 'relative',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  gap: 0,
  justifyItems: 'center',
  alignItems: 'start',
  justifyContent: 'center',
  alignContent: 'start',
  overflow: 'hidden',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  maxHeight: _constants.maxContainerHeight,
  background: theme.palette.common.white,
  borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} ${_constants.LARGE_COMPONENT_RADIUS} 0 0`,
  paddingTop: theme.spacing(9),
  [theme.breakpoints.up('lg')]: {
    justifyItems: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    gridTemplateColumns: `${_constants.arrowBig}px 1fr ${_constants.arrowBig}px`,
    gridTemplateRows: '1fr 40px',
    gap: `0 ${_constants.gapBig}px`,
    maxWidth: _constants.maxContainerWidth,
    maxHeight: _constants.maxMDContainerHeight,
    background: 'none',
    paddingTop: 0,
    marginTop: theme.spacing(8)
  }
}));
const ItemHolder = exports.ItemHolder = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridColumn: '1 / 2',
  gridRow: '1 / 2',
  position: 'relative',
  boxSizing: 'border-box',
  background: theme.palette.common.white,
  borderRadius: `${_constants.LARGE_COMPONENT_RADIUS} ${_constants.LARGE_COMPONENT_RADIUS} 0 0`,
  maxWidth: '100%',
  height: '100%',
  maxHeight: _constants.maxContainerHeight,
  overflowY: 'auto',
  [theme.breakpoints.up('lg')]: {
    gridColumn: '2 / 3',
    gridRow: '1 / 2',
    width: `calc(100vw - ${_constants.arrowsPlusGapsBig}px)`,
    height: `calc((100vw - ${_constants.arrowsPlusGapsBig}px) * ${_constants.widthToHeightRatio})`,
    borderRadius: _constants.LARGE_COMPONENT_RADIUS,
    maxWidth: _constants.maxItemWidth,
    maxHeight: _constants.maxItemHeight,
    overflowY: 'hidden'
  }
}));
const Counter = exports.Counter = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'block',
    gridColumn: '2 / 3',
    gridRow: '2 / 3'
  }
}));
const CloseButton = exports.CloseButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: 11,
  [theme.breakpoints.up('lg')]: {
    right: _constants.closeButtonFromRight
  }
}));
